// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'regenerator-runtime/runtime'
import Vue from 'vue'
import FastClick from 'fastclick'
// import VueRouter from 'vue-router'
import App from './App'
import router from './router'
// import less from 'less'
import '../static/iconfont/iconfont.css';
import './css/app.css';
import './css/public.css';
// import './css/public.less';
import func from '@/utils/func';
import api from '@/utils/api';
import infiniteScroll from 'vue-infinite-scroll';
// Vue.use(less);
Vue.use(infiniteScroll);
Vue.prototype.$api = api;
Vue.prototype.$func = func;
FastClick.attach(document.body)
router.beforeEach((to,from,next)=>{
  if(to.meta.title){
    document.title = to.meta.title
  }
  next()
})
Vue.config.productionTip = true;

// if(func.getLocal('token') && func.getLocal('grade') > 2 && (!func.getLocal('node_v1') || func.getLocal('node_v1') == null)){
//   api.getAccess({}).then((res)=>{
//     if(res.data && JSON.stringify(res.data) != '[]'){
//       func.setLocal('node_v1',JSON.stringify(res.data));
//       window.location.href = "/";
//     }
//   })
// }
// console.log('node_v1',func.getLocal('node_v1'));
// 
//  func.setLocal('token','6e8d58272cf28a4566b356c7');//正式
// func.setLocal('token','8ad1388ca1cc8f56b45c3d604a3bf01b');//测试
/* eslint-disable no-new */
new Vue({
  router,
  render: h => h(App)
}).$mount('#app-box')



// WEBPACK FOOTER //
// ./src/main.js